export const CHEQ_HIDDEN_FIELD_ID = 'cq_req_id';

/**
 * A unregistered hidden field with the id CHEQ_HIDDEN_FIELD_ID is used on forms to store an ID generated by a CheQ script tag.
 * This function helps retrieve that value when submitting the form.
 *
 * @returns {string} The value of the hidden field with the id CHEQ_HIDDEN_FIELD_ID
 */
const getCheqHiddenFieldValue = () =>
  document.querySelector<HTMLInputElement>(`#${CHEQ_HIDDEN_FIELD_ID}`)?.value ?? '';
export default getCheqHiddenFieldValue;
